import { useEffect, useRef } from "react";
import { StringParam, useQueryParam } from "routing/QueryParams";
import { collectAncestorFeatureIds } from "./healthTree";
const useHealthCheckLink = (tree, root, lookup, hasReport, initialCheck) => {
  const [currentCheck, setCheck] = useQueryParam("check", StringParam);
  const appliedRef = useRef(false);
  useEffect(() => {
    if (appliedRef.current || !hasReport || !initialCheck || !lookup[initialCheck]) return;
    appliedRef.current = true;
    collectAncestorFeatureIds(root, initialCheck).forEach((id) => tree.expand(id));
    tree.select(initialCheck);
  });
  const selectedId = tree.selectedState[0];
  useEffect(() => {
    const nextCheck = selectedId && selectedId !== root.id ? selectedId : void 0;
    if ((currentCheck != null ? currentCheck : void 0) === nextCheck) return;
    setCheck(nextCheck, "replaceIn");
  }, [selectedId, root.id, currentCheck, setCheck]);
};
export default useHealthCheckLink;
